import { StoreState } from "../types";
import { SaleManageable } from "./types";

export const storeSalesReducer = (
  state: StoreState,
  newSales: Array<SaleManageable>
) => {
  let sales = state ? new Map(state.sales) : new Map();

  newSales.forEach((newSale: SaleManageable) => {
    let assetTypeSales = sales.get(newSale.assetType);
    if (!!assetTypeSales && !assetTypeSales.find((sale: SaleManageable) => sale.id === newSale.id)) {
      assetTypeSales.push(newSale);
    }
  })

  localStorage.setItem(
    "sales",
    JSON.stringify(Array.from(sales.entries()))
  );

  return {
    ...state,
    sales,
  };
};
